module.exports = __webpack_public_path__ + "static/media/az.1edff124.svg";